import script from "./curativeTrack.vue?vue&type=script&setup=true&lang=js"
export * from "./curativeTrack.vue?vue&type=script&setup=true&lang=js"

import "./curativeTrack.vue?vue&type=style&index=0&id=2c24b163&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c24b163"]])

export default __exports__